export default "__VITE_ASSET__C7sdvey3__"